import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    dependencies: Object,
    exclusions: Object,
    attributeName: String
  }

  connect() {
    this.setupDependencyListeners()
  }

  setupDependencyListeners() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this))
    })
  }

  handleCheckboxChange(event) {
    const changedCheckbox = event.target
    const attributeValue = changedCheckbox.value

    if (changedCheckbox.checked) {
      this.selectDependencies(attributeValue)
      this.deselectExclusions(attributeValue)
    } else {
      this.deselectDependents(attributeValue)
    }
  }

  // The inverse of dependencies: unchecking the attribute(s) this one is mutually exclusive with,
  // declared via `exclusions:` on the step (e.g. subscriber_type/subscriber vs modify_subscriber).
  deselectExclusions(attributeValue) {
    const exclusions = this.exclusionsValue[attributeValue] || []

    exclusions.forEach(excludedAttribute => {
      const excludedCheckbox = this.findCheckboxByValue(excludedAttribute)
      if (excludedCheckbox && excludedCheckbox.checked) {
        excludedCheckbox.checked = false
        excludedCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }

  selectDependencies(attributeValue) {
    const dependencies = this.dependenciesValue[attributeValue] || []

    dependencies.forEach(depAttribute => {
      const depCheckbox = this.findCheckboxByValue(depAttribute)
      if (depCheckbox && !depCheckbox.checked) {
        depCheckbox.checked = true
        depCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }

  deselectDependents(attributeValue) {
    // Find all checkboxes that depend on this attribute
    Object.entries(this.dependenciesValue).forEach(([attr, deps]) => {
      if (deps.includes(attributeValue)) {
        const dependentCheckbox = this.findCheckboxByValue(attr)
        if (dependentCheckbox && dependentCheckbox.checked) {
          dependentCheckbox.checked = false
          dependentCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    })
  }

  findCheckboxByValue(value) {
    return this.checkboxTargets.find(checkbox => checkbox.value === value)
  }
}
